// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { UserProvider } from './components/auth/UserContext';

import Index from './pages/index/index';
import CategoriesIndex from "./pages/categories-index/categories-index";
import SearchResult from "./pages/searchresult/searchresult";
import Series from "./pages/series/series";

const App = () => {
  return (
      <UserProvider>
        <Router>
            <Switch>
                <Route exact path="/" component={Index} />
                <Route path="/categories/:categoryId" component={CategoriesIndex} />
                <Route path="/searchresults" component={SearchResult} />
                <Route path="/series/:seriesId" component={Series} />
            </Switch>
        </Router>
      </UserProvider>
  );
};

export default App;
